import { render, staticRenderFns } from "./ScheduleItemGroup.vue?vue&type=template&id=08036e94&"
import script from "./ScheduleItemGroup.vue?vue&type=script&lang=js&"
export * from "./ScheduleItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleItemGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports